export enum Currency {
    GBP = 0,
    USD = 1,
    EUR = 2,
  }

  export const currencyOptions = [
    { label: '£', value: Currency.GBP },
    { label: '$', value: Currency.USD },
    { label: '€', value: Currency.EUR }
  ];